"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _PublishInformation = _interopRequireDefault(require("../PublishInformation"));
var _VersionsTableButton = _interopRequireDefault(require("../VersionsTableButton"));
var _MinorVersionDropdownMenu = _interopRequireDefault(require("../MinorVersionDropdownMenu"));
var _PatchVersionProperties = _interopRequireDefault(require("./PatchVersionProperties"));
var _MajorVersionProperties = _interopRequireDefault(require("./MajorVersionProperties"));
var _CustomerMetadata = _interopRequireDefault(require("../CustomerMetadata"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var styles = {
  "minor-version-properties": "MinorVersionProperties__minor-version-properties__1bdZL",
  "minorVersionProperties": "MinorVersionProperties__minor-version-properties__1bdZL",
  "row-top": "MinorVersionProperties__row-top__1ZUUr",
  "rowTop": "MinorVersionProperties__row-top__1ZUUr",
  "row-botton": "MinorVersionProperties__row-botton__D_uqY",
  "rowBotton": "MinorVersionProperties__row-botton__D_uqY",
  "right-side": "MinorVersionProperties__right-side__nBx0m",
  "rightSide": "MinorVersionProperties__right-side__nBx0m",
  "left-side": "MinorVersionProperties__left-side__PpM1R",
  "leftSide": "MinorVersionProperties__left-side__PpM1R",
  "custom-metadata": "MinorVersionProperties__custom-metadata__2Wt00",
  "customMetadata": "MinorVersionProperties__custom-metadata__2Wt00",
  "small-separator": "MinorVersionProperties__small-separator__Ma1Q9",
  "smallSeparator": "MinorVersionProperties__small-separator__Ma1Q9",
  "big-separator": "MinorVersionProperties__big-separator__9ygRI",
  "bigSeparator": "MinorVersionProperties__big-separator__9ygRI",
  "right-container": "MinorVersionProperties__right-container__2lITU",
  "rightContainer": "MinorVersionProperties__right-container__2lITU"
}; 
require('./MinorVersionProperties.css');
var MinorVersionProperties = function MinorVersionProperties(_ref) {
  var _createdBy$firstName, _createdBy$lastName;
  var asset = _ref.asset;
  var portalContext = (0, _react.useContext)(_exchangeReactHooks.AssetPortalContext);
  var separator = portalContext.versionsNavigation === 'version-group' ? styles.smallSeparator : styles.bigSeparator;
  var createdBy = asset.createdBy,
    createdAt = asset.createdAt;
  var publishingUser = "".concat((_createdBy$firstName = createdBy === null || createdBy === void 0 ? void 0 : createdBy.firstName) !== null && _createdBy$firstName !== void 0 ? _createdBy$firstName : '', " ").concat((_createdBy$lastName = createdBy === null || createdBy === void 0 ? void 0 : createdBy.lastName) !== null && _createdBy$lastName !== void 0 ? _createdBy$lastName : '');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.minorVersionProperties
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.rowTop
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.leftSide
  }, /*#__PURE__*/_react.default.createElement(_PublishInformation.default, {
    publishingUser: publishingUser,
    publishingDate: createdAt
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles.rightSide, styles.rightContainer)
  }, /*#__PURE__*/_react.default.createElement(_VersionsTableButton.default, {
    asset: asset
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: separator
  }), /*#__PURE__*/_react.default.createElement(_MajorVersionProperties.default, {
    asset: asset
  }), /*#__PURE__*/_react.default.createElement(_MinorVersionDropdownMenu.default, {
    asset: asset
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.rowBotton
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles.leftSide, styles.customMetadata)
  }, /*#__PURE__*/_react.default.createElement(_CustomerMetadata.default, {
    asset: asset
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.rightSide
  }, /*#__PURE__*/_react.default.createElement(_PatchVersionProperties.default, {
    asset: asset
  }))));
};
var _default = exports.default = MinorVersionProperties;
//# sourceMappingURL=MinorVersionProperties.js.map